import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD, HREF_FIELD, TITLE_FIELD } from "../commonFields";

export const threadIntegrationBlockConfig: Omit<
  RegisteredComponent,
  "component"
> = {
  name: "Thread Integration",
  shouldReceiveBuilderProps: {
    builderBlock: true,
    builderContext: true,
    builderComponents: true,
    builderLinkComponent: true,
  },
  inputs: [
    {
      name: "theme",
      localized: false,
      type: "enum",
      enum: [
        { label: "White", value: "white" },
        { label: "Gray", value: "gray" },
      ],
      defaultValue: "white",
      friendlyName: "Theme",
      description: "Select the theme for the thread integration",
    },
    {
      name: "limit",
      type: "number",
      localized: false,
      defaultValue: 5,
    },
    {
      name: "source",
      type: "enum",
      enum: ["THWACK Blogs Json"],
      defaultValue: "THWACK Blogs Json",
      friendlyName: "Source",
      localized: false,
      description: "Select the source for the thread integration",
    },
    {
      name: "headline",
      type: "string",
      localized: true,
      defaultValue: {
        "@type": "@builder.io/core:LocalizedValue",
        Default: "This text is bold",
      },
    },
    {
      name: "link",
      type: "object",
      subFields: [
        {
          ...TITLE_FIELD,
          required: false,
          localized: false,
        },
        HREF_FIELD,
        {
          ...DLD_FIELD,
          required: false,
        },
        {
          ...DLT_FIELD,
          required: false,
        },
      ],
    },
  ],
};
